"use client";

import { createContext, ReactNode, useContext } from "react";

export interface ILoyaltyBrandContext {
  brandSlug: string;
  brandName: string;
  logoUrl: string;
  lastOrderDays: number;
}

export const LoyaltyBrandContext = createContext<ILoyaltyBrandContext | null>(
  null
);

interface ILoyaltyBrandProviderProps {
  children: ReactNode;
  value: ILoyaltyBrandContext;
}

export const LoyaltyBrandProvider = ({
  children,
  value,
}: ILoyaltyBrandProviderProps) => {
  return (
    <LoyaltyBrandContext.Provider value={value}>
      {children}
    </LoyaltyBrandContext.Provider>
  );
};

export const useLoyaltyBrandContext = () => {
  const context = useContext(LoyaltyBrandContext);

  if (!context) {
    throw new Error(
      "useLoyaltyBrandContext must be used within a LoyaltyBrandProvider"
    );
  }

  return context;
};
